module.exports = __webpack_public_path__ + "static/media/ic_user_account.5bc2b188.svg";